// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"Footer_footerContent__Csu-T","footerText":"Footer_footerText__1cItO","socialButton":"Footer_socialButton__17FEq","socialButtons":"Footer_socialButtons__2kPWN"};